import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

const CONTINUE_KEY = 'pb.desktopContinueInApp';
const REQUESTED_PATH_KEY = 'pb.desktopRequestedPath';

function storageGet(key: string): string | null {
  try { return sessionStorage.getItem(key); } catch { return null; }
}

function storageSet(key: string, value: string): void {
  try { sessionStorage.setItem(key, value); } catch { /* Browser storage may be disabled. */ }
}

export function shouldOfferDesktopHandoff(): boolean {
  return !Capacitor.isNativePlatform()
    && typeof window !== 'undefined'
    && window.matchMedia?.('(hover: hover) and (pointer: fine)').matches === true
    && storageGet(CONTINUE_KEY) !== '1';
}

export const desktopHandoffGuard: CanMatchFn = (_route, segments) => {
  if (!shouldOfferDesktopHandoff()) return true;

  const requestedPath = `/${segments.map(segment => segment.path).join('/')}`;
  storageSet(REQUESTED_PATH_KEY, requestedPath);
  return inject(Router).parseUrl('/desktop');
};

export function continueInMobileApp(): string {
  const requestedPath = storageGet(REQUESTED_PATH_KEY);
  storageSet(CONTINUE_KEY, '1');
  // Never treat browser storage as an external redirect destination.
  return requestedPath === '/login' || requestedPath?.startsWith('/tabs/')
    ? requestedPath
    : '/tabs/home';
}
